import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardGpkPegawai } from 'app/KinerjaGpkPage/components/PageGuardGpkPegawai'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'
import { PageGuardGpkPelaksanaanDate } from 'app/KinerjaGpkPage/components/PageGuardGpkPelaksanaanDate'
import { PerilakuKerja } from 'app/KinerjaGpkPage/pages/pegawai/pelaksanaan/PerilakuKerja'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isKinerjaGpkEnabled = toggle?.['kinerja-gpk-enabled'] || false

    if (!isKinerjaGpkEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <PageGuardGpkPegawai>
      <PageGuardGpkPelaksanaanDate>
        <KinerjaTipeProvider tipe="GPK">
          <PerilakuKerja />
        </KinerjaTipeProvider>
      </PageGuardGpkPelaksanaanDate>
    </PageGuardGpkPegawai>
  )
}

Page.Layout = KinerjaLayout
